import React from 'react';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle
} from '../../ui/sheet';
import { Summary } from './Summary';
import { Section } from './Section';

const AssignmentReviewDrawer = (props) => {
  const {
    answerStatuses,
    assignmentQuestionSections,
    assignmentQuestions,
    isOpen,
    onClose
  } = props;

  if (!answerStatuses) {
    return null;
  }

  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && onClose?.()}>
      <SheetContent side="right" className="flex w-full flex-col p-0 sm:max-w-sm">
        <SheetHeader className="flex-shrink-0 border-b border-border/50 p-4">
          <SheetTitle>Review Navigation</SheetTitle>
          <SheetDescription>Jump to any question and see your results.</SheetDescription>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto px-4 py-4">
          <Summary answerStatuses={answerStatuses} />
          <Section
            id={1}
            answerStatuses={answerStatuses}
            closeDrawer={onClose}
            assignmentQuestionSections={assignmentQuestionSections}
            assignmentQuestions={assignmentQuestions}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
};

export { AssignmentReviewDrawer };
